import React from 'react';
import { Form, Collapse } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { formatFirstCharacterWithSpace } from '@utils/widget';

import RichEditor from '../richEditor';
import '../sections/strategy/strategy.scss';
// import RichEditor from '../richEditor';
const { Panel } = Collapse;

const formatHeader = (itm) => {
  switch (itm) {
    case 'regulatory':
      return 'Regulatory & Legal';
    case 'territoryVSProducts':
      return 'Territory vs. products';
    case 'centralVSDecentral':
      return 'Centralization vs. Decentralization';
    case 'spansAndLayers':
      return 'Spans and Layers';
    default:
      return formatFirstCharacterWithSpace(itm);
  }
};

//
const CollapseComp = ({
  isEditing,
  optionText,
  seqNum,
  optionLevel,
  executionCollapseHandler,
  selectMode,
  // textChange,
  text,
}) => (
  // debugger;
  <div className="complexity-collapse">
    {isEditing && (
      <Collapse
        defaultActiveKey={[...Object.keys(optionText)]}
        showArrow={false}
        expandIconPosition="right"
        expandIcon={({ isActive }) => (
          <DownOutlined rotate={isActive ? 180 : 0} />
        )}
      >
        {Object.keys(optionText).map(
          (itm, index) =>
            itm !== 'title' &&
            itm !== 'key' &&
            itm !== 'bottom' && (
              <Panel
                header={formatHeader(itm)}
                key={itm}
                collapsible="disabled"
              >
                <Form.Item
                  initialValue={optionText[itm]}
                  name={
                    selectMode
                      ? null
                      : [`optionCriteria--${seqNum}--${optionLevel}`, itm]
                  }
                >
                  <RichEditor
                    readOnly={!isEditing}
                    value={selectMode ? text[itm] : optionText[itm]}
                    className="complexity-textarea"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                    // onChange={(e) => {
                    //   textChange(e, itm);
                    // }}
                  />
                </Form.Item>
              </Panel>
            ),
        )}
      </Collapse>
    )}

    {!isEditing &&
      (seqNum > 31 ? (
        // for being compatible with execution-collapse
        <Collapse
          activeKey={[optionText.key]}
          showArrow={false}
          expandIconPosition="right"
          expandIcon={({ isActive }) => (
            <DownOutlined rotate={isActive ? 180 : 0} />
          )}
          accordion={true}
          onChange={(key) => {
            if (seqNum > 31) {
              executionCollapseHandler(key, seqNum);
            }
          }}
        >
          {Object.keys(optionText).map(
            (itm, index) =>
              itm !== 'title' &&
              itm !== 'key' && (
                <Panel
                  header={formatHeader(itm)}
                  key={itm}
                  collapsible="disabled"
                >
                  {/* <pre>{optionText[itm]}</pre> */}
                  <RichEditor
                    readOnly={!isEditing}
                    value={optionText[itm]}
                    className="complexity-textarea"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  />
                </Panel>
              ),
          )}
        </Collapse>
      ) : (
        <Collapse
          defaultActiveKey={[
            Object.keys(optionText)[0] === 'title'
              ? Object.keys(optionText)[1]
              : Object.keys(optionText)[0],
          ]}
          showArrow={false}
          expandIconPosition="right"
          expandIcon={({ isActive }) => (
            <DownOutlined rotate={isActive ? 180 : 0} />
          )}
          accordion={true}
        >
          {Object.keys(optionText).map(
            (itm, index) =>
              itm !== 'title' &&
              itm !== 'key' &&
              itm !== 'bottom' && (
                <Panel
                  header={formatHeader(itm)}
                  key={itm}
                  collapsible="disabled"
                >
                  {/* <pre>{optionText[itm]}</pre> */}
                  <RichEditor
                    readOnly={!isEditing}
                    value={optionText[itm]}
                    className="complexity-textarea"
                    autoSize={{ minRows: 3, maxRows: 5 }}
                  />
                </Panel>
              ),
          )}
        </Collapse>
      ))}
  </div>
);
export default CollapseComp;
